// Angular DOM
import { Component, ViewChild, TemplateRef } from "@angular/core";
// Angular Hooks
import { OnInit, AfterViewInit } from "@angular/core";
// Redux Store
import { Store } from "@ngrx/store";
import { SetLocationInfo } from "app/shared/actions";
// Models
import { SearchCriteria, FacilityModel } from "app/shared/models";
// Third Party Services
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
// Services
import { PhysicianService } from "../../services/physician/physician.service";
import { OfficeStaffService } from "../../services/office-staff/office-staff.service";

@Component({
  selector: "app-location-user-assignment-modal",
  templateUrl: "./location-user-assignment-modal.component.html",
  styleUrls: ["./location-user-assignment-modal.component.scss"]
})
export class LocationUserAssignmentModalComponent
  implements OnInit, AfterViewInit {
  @ViewChild("content") template: TemplateRef<any>;
  public modalRef: any;
  public selectedRoleType: string;
  public location: FacilityModel;
  public selectedUserIds: Array<number>;
  public usersForRole: Array<any>;

  private options: NgbModalOptions = {
    backdrop: "static",
    windowClass: "user-assignment",
    container: "app-location-user-assignment-modal",
    size: "lg",
    keyboard: false
  };
  private searchCriteria: SearchCriteria;
  private redirectUrl: string;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private store: Store<any>,
    private physicianService: PhysicianService,
    private officeStaffService: OfficeStaffService
  ) {}

  ngOnInit() {
    this.searchCriteria = new SearchCriteria();
    this.usersForRole = [];
    this.fetchUsers("1");
    this.route.queryParams.subscribe(params => {
      this.redirectUrl = params["redirect"] || "/admin-portal/locations";
    });
    this.store.select("location").subscribe((location: FacilityModel) => {
      this.location = location || new FacilityModel();
      this.selectedUserIds = []
        .concat(this.location.physicians, this.location.staff)
        .map(user => user.Id);
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.modalRef = this.modalService.open(this.template, this.options);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.modalRef.close();
    });
  }

  update() {
    this.store.dispatch(new SetLocationInfo(this.location));
    this.back();
  }

  back() {
    this.router.navigate([this.redirectUrl]);
  }

  onSearchFieldUpdate($event) {
    this.searchCriteria.SearchTerm = $event;
    this.fetchUsers(this.selectedRoleType);
  }

  fetchUsers(role: string) {
    this.selectedRoleType = role;
    switch (role) {
      case "1":
        return this.physicianService
          .getPhysicians(this.searchCriteria)
          .subscribe(physicians => {
            this.usersForRole = physicians;
          });
      case "3":
        this.officeStaffService
          .getAllStaff(this.searchCriteria)
          .subscribe(staff => {
            this.usersForRole = staff;
          });
    }
  }

  onUserCheckboxUpdate(checked, user) {
    this.selectedUserIds = this.selectedUserIds.filter(
      userId => userId !== user.Id
    );

    switch (user.Role) {
      case "physician":
        this.location.physicians = this.location.physicians.filter(
          phys => phys.Id !== user.Id
        );
        break;
      case "staff":
        this.location.staff = this.location.staff.filter(
          staff => staff.Id !== user.Id
        );
        break;
      default:
        throw new Error("User assignment for location, user has invalid role");
    }

    if (checked) {
      this.selectedUserIds.push(user.Id);
      switch (user.Role) {
        case "physician":
          return this.location.physicians.push(user);
        case "staff":
          return this.location.staff.push(user);
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/location-user-assignment-modal/location-user-assignment-modal.component.ts